import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-hearts': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M353.6 304.6c10-3.1 19.3 5.5 17.7 15.3-8 47.1-71.3 80-123.3 80s-115.4-32.8-123.3-80c-1.7-10 7.9-18.4 17.7-15.3 26 8.3 64.4 13.1 105.6 13.1s79.7-4.8 105.6-13.1zM200.8 255.7l-70.2-18.1c-20.4-5.3-31.9-27-24.2-47.2 6.7-17.7 26.7-26.7 44.9-22l7.1 1.9 2-7.1c5.1-18.1 22.9-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5l-19.4 69.9c-1.3 4.5-6 7.2-10.5 6zM389.6 190.4c7.7 20.2-3.8 41.8-24.2 47.1l-70.2 18.2c-4.6 1.2-9.3-1.5-10.5-6l-19.4-69.9c-5.6-20.3 7.4-41.1 28.8-44.5 18.7-3 36.5 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.4 44.9 22zM248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin-hearts.js
// module id = 1751
// module chunks = 0